import { createRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AppLayout } from '@/components/layout/AppLayout';
import { useAuth } from '@/features/auth';
import { rootRoute } from './__root';

/**
 * 認証済みルートのレイアウト。
 *
 * 認証状態を確認し、未認証ユーザーはログインページへリダイレクトする。
 * 認証済みの場合は AppLayout（サイドバー + ヘッダー + メイン領域）を表示する。
 */
function AuthenticatedLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      void navigate({ to: '/login', replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div aria-live="polite" aria-busy="true">
        読み込み中...
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <AppLayout />;
}

export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: '_authenticated',
  component: AuthenticatedLayout,
});
